import { gallery } from "../data";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SectionHeader from "../components/SectionHeader";

export default function Gallery() {
  return (
    <>
      <PageHero
        eyebrow="Gallery"
        title="Moments of craft, calm, and transformation."
        desc="A visual glimpse of bridal work, hair styling, nail art, spa rituals, skin treatment, and salon interiors."
        image="https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad warm-section">
        <div className="container">
          <Reveal>
            <SectionHeader eyebrow="Orchid Gallery" title="Beauty work with an editorial eye." />
          </Reveal>
          <div className="image-grid large">
            {gallery.map((item, index) => (
              <Reveal delay={index * 70} key={item.label}>
                <article className="image-tile bits-spotlight">
                  <img src={item.src} alt={item.label} />
                  <div><span>{String(index + 1).padStart(2, "0")}</span><h3>{item.label}</h3></div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
